import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { ProductOptionListRequestQuery, ProductOptionSearchResponse } from '@lio/api-types';
import { config } from '@services/config';
import { buildQueryParamForArray } from '@utils/buildQueryParamForArray';

export const useProductOptionsList = (params: ProductOptionListRequestQuery) => {
  const client = useClient();

  const queryParams = new URLSearchParams();
  queryParams.append('pageLimit', (params.pageLimit || 25).toString());
  queryParams.append('pageOffset', (params.pageOffset || 0).toString());

  if (params.name) {
    queryParams.append('name', params.name);
  }

  if (params.insuranceProductId) {
    queryParams.append('insuranceProductId', params.insuranceProductId);
  }

  if (params.id) {
    buildQueryParamForArray(queryParams, 'id', params.id);
  }

  if (params.sort) {
    queryParams.append('sort', params.sort);
  }

  const result = useQuery<ProductOptionSearchResponse>({
    queryKey: ['insuranceProductOptionList', params],
    queryFn: () => client.get(`product-option?${queryParams}`).json(),
    ...config,
  });
  return { ...result, productOptionList: { ...result.data, items: result.data?.items ?? [] } };
};
